// extracted by mini-css-extract-plugin
module.exports = {"picture":"wineLabel-module__picture--2DM3o","image":"wineLabel-module__image--3HOnd","imperfectLabel":"wineLabel-module__imperfectLabel--1AqxK"};